"use client";
import { useState } from "react";
import Link from "next/link";

import { usePathname } from "next/navigation";
import { useRouter } from "next/navigation";
const Sidebar = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const path = usePathname();
  const router = useRouter();

  const menus = [
    {
      title: "Hardware Audit",
      link: "/hardware-audit",
    },
  ];
  return (
    <div className="flex flex-row  min-h-screen  w-full relative">
      {/* Sidebar */}
      <div
        className={`flex  flex-col bg-gray-800 text-white  p-5 pt-8 ${
          isOpen ? "w-82" : "w-16"
        } duration-300 `}
      >
        <button
          className="absolute top-4 right-4 text-white"
          onClick={() => setIsOpen(!isOpen)}
        >
          {/* {isOpen ? "❌" : "☰"} */}
        </button>
        <h1 className={`text-2xl font-bold mb-8 ${!isOpen && "hidden"}`}>
          Admin
        </h1>
        <ul className="space-y-4">
          {menus.map((menu, index) => {
            return (
              <li
                key={index}
                className={`${
                  path == menu.link ? "bg-[#cf0fff] text-white font-bold" : ""
                } rounded-2xl p-4 flex flex-row gap-4`}
              >
                <svg
                  className="w-6 h-6 text-white "
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 13v-2a1 1 0 0 0-1-1h-.757l-.707-1.707.535-.536a1 1 0 0 0 0-1.414l-1.414-1.414a1 1 0 0 0-1.414 0l-.536.535L14 4.757V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v.757l-1.707.707-.536-.535a1 1 0 0 0-1.414 0L4.929 6.343a1 1 0 0 0 0 1.414l.536.536L4.757 10H4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h.757l.707 1.707-.535.536a1 1 0 0 0 0 1.414l1.414 1.414a1 1 0 0 0 1.414 0l.536-.535 1.707.707V20a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-.757l1.707-.708.536.536a1 1 0 0 0 1.414 0l1.414-1.414a1 1 0 0 0 0-1.414l-.535-.536.707-1.707H20a1 1 0 0 0 1-1Z"
                  />
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                  />
                </svg>

                <Link href={menu.link}>
                  <span className={`hover:text-gray-300  `}>{menu.title}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>

      <div className=" w-full p-7">{children}</div>
    </div>
  );
};

export default Sidebar;
